import { useState, useMemo } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { ReactComponent as XIcon } from "../../assets/icons/close-icon.svg";
import ClimbingBoxLoader from "react-spinners/ClimbingBoxLoader";
import { api } from "../..";

const HeightUpdate = ({ showHeightUpdate, setShowHeightUpdate, id }) => {
  const [babyHeight, setBabyHeight] = useState();
  const [babyHeightTimeFrame, setBabyHeightTimeFrame] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const updateBabyHeight = () => {
    setLoading(true);
    api
      .post(`api/child_height`, {
        child_id: id,
        height: babyHeight,
        time_frame: babyHeightTimeFrame,
      })
      .then((res) => {
        toast.success("Height updated successfully");
        setBabyHeight("");
        setBabyHeightTimeFrame("");
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        toast.error("An error occured. Please try again");
        setLoading(false);
      });
  };

  return (
    <div className="addChild__container">
      {loading ? (
        <div
          className="loader__container"
          style={{ height: "100vh", position: "fixed" }}
        >
          <ClimbingBoxLoader color="#ffffff" loading={loading} size={15} />
        </div>
      ) : null}
      <div
        className="addUserForm__content--container"
        style={{ height: "100%", width: "100vw" }}
      >
        <div className="addState__form">
          <span className="form__heading-and-close--CTA">
            <p className="addUserForm__formheading">Baby Height Update</p>
            <XIcon
              style={{ fill: "#F95959", cursor: "pointer" }}
              onClick={() => setShowHeightUpdate(!showHeightUpdate)}
            />
          </span>
          <label htmlFor="state" className="addUserForm__password--label">
            Baby Height
          </label>
          <div className="addUserForm__password-and-icons">
            <input
              type="text"
              className={
                errorMessage ? "email--input" : "addChild__email--input"
              }
              id="state"
              autoComplete="off"
              value={babyHeight}
              onChange={(e) => setBabyHeight(e.target.value)}
              style={{ width: "100%", margin: "1.5rem 0rem" }}
              required
              placeholder="Please Enter Baby's Height (Number Only)"
              aria-describedby="uidnote"
            />

            <label
              htmlFor="heightTimeFrame"
              className="addUserForm__password--label"
            >
              Height Time-Frame
            </label>
            {/* <input
              type="text"
              className={
                errorMessage ? "email--input" : "addChild__email--input"
              }
              id="fileTitle"
              autoComplete="off"
              placeholder="Please Enter Height Period (e.g 1Week or 2Months)"
              onChange={(e) => setBabyHeightTimeFrame(e.target.value)}
              value={babyHeightTimeFrame}
              style={{ width: "100%", marginTop: "1.5rem" }}
              required
            /> */}
            <select
              // name="countries"
              id="heightTimeFrame"
              className={
                errorMessage ? "email--input" : "addChild__email--input"
              }
              value={babyHeightTimeFrame}
              style={{ width: "100%", marginTop: "1.5rem" }}
              required
              onChange={(e) => setBabyHeightTimeFrame(e.target.value)}
            >
              <option value=""></option>
              <option value="birth">Birth</option>
              <option value="2weeks">2 Weeks</option>
              <option value="6weeks">6 Weeks</option>
              <option value="1month">1 Month</option>
              <option value="2months">2 Months</option>
              <option value="5months">5 Months</option>
              <option value="1year">1 Year</option>
              <option value="1year+">1 Year+</option>
              <option value="2years">2 Years</option>
              <option value="3years">3 Years</option>
              <option value="5years">5 Years</option>
            </select>
            {errorMessage && (
              <p
                style={{
                  color: "#F95959",
                  marginTop: "1rem",
                }}
              ></p>
            )}
          </div>
          <button
            className="addUserForm__submit--CTA"
            style={{ width: "100%" }}
            onClick={() => updateBabyHeight()}
            disabled={!babyHeight || !babyHeightTimeFrame ? true : false}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeightUpdate;
